<style lang="less" scoped>
  .btn {
    width: 44px;
    height: 44px;
    display: flex;
    align-content: center;
    justify-content: center;
  }
</style>

<template lang="pug">
  img.btn(:src='"@/assets/buttons/top-nav-back@2x.png"')
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      default: null,
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/header_back_btn.vue